<template>
  <div>
    <div class="shouye" id="tensor">
            <!--top-->
            <div class="top">
                <!--nav-->
                   <Nav></Nav>          
                <!--nav-end-->
                <!--banner-->
                <div class="banner">
                                        <div class="layui-carousel" id="test10"  v-if="advertisement">
                        <div class="layui-cen" carousel-item="">
                            <div v-for="(adkv,i) in advertisement.adList" :key="i">
                                  <img :src="adkv.image" v-if="adkv.jumpType==0">
                                  <a :href="adkv.jumpUrl" target="_blank" v-else><img :src="adkv.image"></a>
                            </div>
                        </div>
                    </div>

                </div>
                <!--banner-end-->
            </div>
            <!--top-end-->
            <!--center-->
            <div class="shouye-center">
               <A></A>
               <B></B>
               <C></C>
               <D></D>
            </div>
            <!--center-end-->
            <!--footer-->
               <Footer></Footer>
            <!--footer-end-->
        </div>
        <Backtop></Backtop>
  </div>
</template>

<script>
import Nav from '@c/Main/Nav/index.vue'
import Footer from '@c/Main/Footer/index.vue'
import Backtop from '@c/Main/Backtop/index.vue'
import A from './a.vue'
import B from './b.vue'
import C from './c.vue'
import D from './d.vue'
export default {
  components: { Nav, Footer, Backtop, A, B, C, D },
  name: 'Home',
  data () {
    return {
      advertisement: this.$store.state.advertisement
    }
  },
  watch: {
    '$store.state.advertisement'(obj){
        this.advertisement = obj
        this.$nextTick(() => {
          layui.use(['carousel', 'form'], function() {
            var carousel = layui.carousel
            //图片轮播
            carousel.render({
                elem: '#test10',
                width: '100%',
                height: '10.5rem',
                interval: obj.adIntervalTime * 1000
            });
          });
        })
    }
  },
  mounted(){
    if(this.advertisement){
      var _this = this
      layui.use(['carousel', 'form'], function() {
            var carousel = layui.carousel
            //图片轮播
            carousel.render({
                elem: '#test10',
                width: '100%',
                height: '10.5rem',
                interval: _this.advertisement.adIntervalTime * 1000
            });
          });
    }
           $(document).ready(function(){
                    resizeHtml();
     //为了防止用户拖动窗口自适应大小
                    $(window).resize(function() {
                            resizeHtml();
                    });
    });
      function resizeHtml(){
//main为body下第一层div的id
              $('#tensor').height($(window).width());
      }
    

     
  }
}
</script>
<style>
@import '~@/static/skin/web/css/index.css';
</style>